exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-notify{text-align:center;box-sizing:border-box;padding:6px 15px;font-size:14px;line-height:20px;white-space:pre-wrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vant/es/notify/index.css
// module id = 386
// module chunks = 0